export { render, renderToDOM } from './render';
export var parameters = {
  framework: 'react'
};